import { useStoreMediaDevices } from '@/entities/media-devices'

import { useEmptyMediaStream } from './empty-media-stream'

export const useUserMediaStream = () => {

  const getUserMedia = async (audio: boolean, video: boolean, useMediaStubs = false): Promise<MediaStream> => {
    if (useMediaStubs && !audio && !video) {
      return useEmptyMediaStream().getEmptyMediaStream()
    }
    const { openMedia } = useStoreMediaDevices()
    return openMedia(audio, video).then((mediaStream) => {
      if (useMediaStubs && !audio) {
        const { getEmptyAudioTrack } = useEmptyMediaStream()
        const track = getEmptyAudioTrack()
        track.enabled = false
        mediaStream.addTrack(track)
      }
      if (useMediaStubs && !video) {
        const { getEmptyVideoTrack } = useEmptyMediaStream()
        const track = getEmptyVideoTrack()
        track.enabled = false
        mediaStream.addTrack(track)
      }
      return mediaStream
    })
  }

  return {
    getUserMedia,
  }
}
